import { colors } from './colors'
import { light } from './prism'

/**
 * Shadow tokens.
 *
 * Named shadows defined in a plain object
 *
 * For use with the following CSS properties:
 *
 *     box-shadow, text-shadow
 *
 * @see https://system-ui.com/theme
 */

export const shadows = {
  boxShadow: {
    elevated: `0 7px 25px 0  ${colors.border.dark.high}`,
    raised: `0 3px 12px 0  ${colors.border.dark.high}`,
    lifted: `0 2px 5px 0 ${colors.border.dark.base}`,
    subtle: `0 1px 3px 0  ${colors.border.dark.base}`,
    inner: `inset 0 1px 2px 0 ${light.colors.shadow.inner}`,
    outer: `0 4px 8px 0 ${light.colors.shadow.outer}`,
  },
  focus: `0 0 0 2px ${colors.background.light.base}, 0 0 0 4px ${colors.focus.generic}`,
}
